import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, map, Observable, throwError } from 'rxjs';
import { environment } from '../../environments/environment';
import { VehOrigen } from '../models/VehOrigen';


@Injectable({
    providedIn: 'root'
})
export class VehOrigenService {

    private url = "";
    private apiEndpoint = environment.vehOrigenUrl;


    constructor(private readonly httpClient:HttpClient) { }

    getVehOrigenTable(): Observable<VehOrigen[]> {
        this.url = this.apiEndpoint;
        console.log(this.url);
        return this.httpClient.get<VehOrigen[]>(this.url).pipe(
          map((res: VehOrigen[]) => {
            return res;
          })
        );
    }

}
